module.exports = __webpack_public_path__ + "media/images/chat-bubble-54c8f9dd5b358c9da0d33a82b959fa61.svg";